import { compose, prop } from 'ramda';
import { useTranslations } from 'js/hooks/i18n';
import { Link } from 'js/components/common/Link';
import { useUserSelector } from 'js/store/hooks';
import { Loader } from 'js/components/common/Loader';
import { useMountEffect } from 'js/hooks/useMountEffect';
import React, { useCallback, useEffect, useState } from 'react';
import { componentService } from 'js/services/component.service';
import { withComponent } from 'js/components/hocs/withComponent';

import { getPlayerSelfExclusion } from './server';

import style from './SelfExclusion.scss';

export const SelfExclusionBare = ({ href = '/self-exclusion', showComponentError }) => {
    const t = useTranslations('playtech.mobile.system.SelfExclusion.');
    const [isLoading, setIsLoading] = useState(false);
    const [isPrevented, setIsPrevented] = useState(false);
    const [isPreventedByIMS, setIsPreventedByIMS] = useState(false);
    const { ageVerificationStatus } = useUserSelector(prop('userDetails'));

    // todo remove after core Link support disable state
    const onClick = useCallback((event) => {
        if (isPrevented) {
            event.preventDefault();
        }
    }, [isPrevented]);

    useEffect(() => {
        if (!ageVerificationStatus) {
            return;
        }

        if (ageVerificationStatus !== 'passed') {
            setIsPrevented(true);
        }
    }, [setIsPrevented, ageVerificationStatus]);

    useMountEffect((isMounted) => {
        setIsLoading(true);

        getPlayerSelfExclusion()
            .then(response => {
                if (!isMounted()) {
                    return;
                }

                if (!response?.data?.allowed) {
                    setIsPreventedByIMS(true);
                }

                setIsLoading(false);
            })
            .catch(() => {
                if (!isMounted()) {
                    return;
                }

                showComponentError(t('fetchError'));
                setIsLoading(false);
            });
    }, [setIsPreventedByIMS, setIsLoading, t, showComponentError]);

    if (isLoading) {
        return <Loader />;
    }

    return (
        <div className={style.container}>
            <h3 className={style.title}>{t(`title${isPreventedByIMS ? '.disabled' : ''}`)}</h3>
            <p className={style.description}>{t(`description${isPreventedByIMS ? '.disabled' : ''}`)}</p>
            {!isPreventedByIMS && <Link
                href={href}
                onClick={onClick}
                className={`${style.button} ${isPrevented ? style.isPrevented : ''}`}
            >
                {t('button')}
            </Link>}
        </div>
    );
};

export const SelfExclusion = compose(
    withComponent({ isForLoggedIn: true })
)(SelfExclusionBare);

componentService.registerWebContentComponents({ SelfExclusion });
